import * as types from "./types";

export const requestingAuth = _ => ({
  type: types.REQUESTING_AUTH,
  loading: true
});
export const errorRequestingAuth = error => ({
  type: types.ERROR_REQUESTING_AUTH,
  error: error,
  loading: false
});

export const receivedAuth = (accessToken, refreshToken) => ({
  type: types.RECEIVED_AUTH,
  accessToken: accessToken,
  refreshToken: refreshToken,
  loading: false
});

export const refreshingToken = _ => ({
  type: types.REFRESHING_TOKEN,
  accessToken: "",
  loading: true
});

export const refreshedToken = accessToken => ({
  type: types.REFRESHED_TOKEN,
  accessToken: accessToken,
  loading: false
});

export const logout = _ => ({
  type: types.LOGOUT,
  accessToken: "",
  refreshToken: ""
});

export const creatingAccount = _ => ({
  type: types.CREATING_ACCOUNT,
  loading: true
});
export const createdAccount = _ => ({
  type: types.CREATED_ACCOUNT,
  loading: false
});
export const errorCreatingAccount = error => ({
  type: types.ERROR_CREATING_ACCOUNT,
  error: error,
  loading: false
});
